import Link from 'next/link';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { ArrowRight, Briefcase, UserRound } from 'lucide-react';
import type { ReactElement } from 'react';

export function AccessCards(): ReactElement {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 max-w-4xl mx-auto">
      <Link href="/individual/login" className="group">
        <Card className="relative overflow-hidden transition-all duration-300 hover:shadow-xl hover:shadow-purple-500/10 hover:-translate-y-1 border-0 bg-gradient-to-br from-white to-purple-50/50 dark:from-gray-900 dark:to-purple-950/50">
          <CardHeader className="pb-4">
            <div className="flex items-center gap-4">
              <div className="size-12 rounded-xl bg-gradient-to-br from-purple-500 to-purple-600 text-white grid place-items-center shadow-lg">
                <UserRound className="size-6" />
              </div>
              <div>
                <CardTitle className="text-xl mb-1">Individual Access</CardTitle>
                <Badge variant="outline" className="text-xs">Personal Journey</Badge>
              </div>
            </div>
          </CardHeader>
          <CardContent className="pt-0">
            <p className="text-muted-foreground mb-6">
              Begin your personal discovery journey with detailed insights tailored just for you.
            </p>
            <Button size="sm" className="w-full group-hover:bg-blue-600 transition-colors">
              Start Personal Assessment
              <ArrowRight className="ml-2 size-4 group-hover:translate-x-1 transition-transform" />
            </Button>
          </CardContent>
        </Card>
      </Link>

      <Link href="/corporate" className="group">
        <Card className="relative overflow-hidden transition-all duration-300 hover:shadow-xl hover:shadow-blue-500/10 hover:-translate-y-1 border-0 bg-gradient-to-br from-white to-blue-50/50 dark:from-gray-900 dark:to-blue-950/50">
          <CardHeader className="pb-4">
            <div className="flex items-center gap-4">
              <div className="size-12 rounded-xl bg-gradient-to-br from-blue-500 to-blue-600 text-white grid place-items-center shadow-lg">
                <Briefcase className="size-6" />
              </div>
              <div>
                <CardTitle className="text-xl mb-1">Corporate Access</CardTitle>
                <Badge variant="outline" className="text-xs">For Organizations</Badge>
              </div>
            </div>
          </CardHeader>
          <CardContent className="pt-0">
            <p className="text-muted-foreground mb-6">
              Access your corporate account with enhanced team insights and organizational analytics.
            </p>
            <Button size="sm" className="w-full group-hover:bg-blue-600 transition-colors">
              Access Corporate Portal
              <ArrowRight className="ml-2 size-4 group-hover:translate-x-1 transition-transform" />
            </Button>
          </CardContent>
        </Card>
      </Link>
    </div>
  );
}

